import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const CibilReportModal = ({ reportUrl }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (reportUrl) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Typography
        style={{
          fontSize: 15,
          fontWeight: 600,
          color: "#1976D2",
          cursor: reportUrl ? "pointer" : "default",
          textDecoration: reportUrl ? "underline" : "none",
        }}
        onClick={handleOpen}
      >
        {reportUrl ? "View CIBIL Report" : "NA"}
      </Typography>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>
          CIBIL Report

          <IconButton
            onClick={handleClose}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          style={{
            padding: 0,
            height: "80vh",
          }}
        >
          {reportUrl && (
            <iframe
              src={reportUrl}
              title="CIBIL Report"
              width="100%"
              height="100%"
              style={{
                border: "none",
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

CibilReportModal.propTypes = {
  reportUrl: PropTypes.string,
};

export default CibilReportModal;